export default {
    "lang": "德语",
    application: {
        name: 'Informationsveröffentlichungssystem',
    },
    ajaxTip: {
        success: 'Erfolgreich',
        error: 'Fehlgeschlagen',
        noAccess: 'Zugriff auf diese Ressource nicht gestattet',
        notFound: 'Die aufgerufene Ressource existiert nicht',
        serverBusy: 'Server ist beschäftigt',
        timeOut: 'Zeitüberschreitung',
    },
    menu: {
        home: 'Startseite',
        template: 'Vorlagenverwaltung',
        program: 'Programmverwaltung',
        playplan: 'Wiedergabeplan',
        device: 'Geräteverwaltung',
        "source-material": 'Materialverwaltung',
        material: 'Material',
        checkManage: 'Prüfungsverwaltung',
        setting: 'Einstellungen',
        usercenter: "Benutzerzentrum",
        adminManage: "Geräteverwaltung",
        schedule: "Anstehende Aufgaben",
        capitalassets: "Asset-Management",
        modifyPassword: "Passwort ändern",
        logout: "Abmelden",
        "add": "Hinzufügen",
        "edit": "Bearbeiten",
        "delete": "Löschen",
        "view": "Anzeigen",
        "menu_1": "Startseite",
        "menu_2": "Geräteverwaltung",
        "menu_3": "Bearbeiten (Erweiterte Einstellungen - Grundlegende Bearbeitung - Netzwerk wechseln)",
        "menu_4": "Sofortbefehle",
        "menu_5": "Bearbeiten (Abteilung übertragen)",
        "menu_6": "Strategie",
        "menu_7": "Lautstärkeeinstellungen",
        "menu_8": "Helligkeitseinstellungen",
        "menu_9": "Herunterladungseinstellungen",
        "menu_10": "Schlafmodus Einstellungen",
        "menu_11": "Geräteeigenschaften",
        "menu_12": "Bearbeiten/Hinzufügen",
        "menu_13": "Programmverwaltung",
        "menu_14": "Veröffentlichungsverlauf",
        "menu_15": "Löschen (Batch/Einzeln)",
        "menu_16": "Veröffentlichende Programme",
        "menu_17": "Gruppierung",
        "menu_19": "Programmliste",
        "menu_20": "Inhaltsbearbeitung",
        "menu_21": "Programm kopieren",
        "menu_23": "Programm veröffentlichen",
        "menu_24": "Materialverwaltung",
        "menu_25": "Hochladen",
        "menu_28": "Schnellveröffentlichung",
        "menu_29": "Vorlagenverwaltung",
        "menu_30": "Öffentliche Vorlagen",
        "menu_31": "Jetzt verwenden",
        "menu_32": "Meine Vorlagen",
        "menu_33": "In öffentliche Vorlagen veröffentlichen",
        "menu_35": "Teileverlauf",
        "menu_36": "Prüfungsverwaltung",
        "menu_37": "Programmprüfung",
        "menu_38": "Prüfen (Genehmigen/Ablehnen)",
        "menu_39": "Materialprüfung",
        "menu_41": "Prüfverlauf (Betreiber)",
        "menu_42": "Prüfverlauf (Prüfer)",
        "menu_43": "Genehmigungsmenge anzeigen",
        "menu_44": "Organisationsverwaltung",
        "menu_45": "Protokollverwaltung",
        "menu_46": "Wiedergabeprotokolle",
        "menu_47": "Veröffentlichungsprotokolle",
        "menu_48": "Fehlerprotokolle",
        "menu_49": "Operationsprotokolle",
        "menu_50": "Dateiprotokolle",
        "menu_51": "Anmeldeprotokolle",
        "menu_52": "Inhaltsgenehmigung",
        "menu_53": "Speicherspace",
        "menu_54": "Organisationsstruktur",
        "menu_55": "Rollenberechtigungen",
        "menu_56": "Autorisierung",
        "menu_57": "Anzeigen (Autorisierungsberechtigungen)",
        "menu_58": "Organisationsmitglieder",
        "menu_60": "Passwörter untergeordneter Benutzer zurücksetzen",
        "menu_61": "Asset-Management",
        "menu_62": "Mein Guthaben",
        "menu_63": "Anzeigen (Fondsdaten)",
        "menu_64": "Mein Datenverbrauch",
        "menu_65": "Anzeigen (Datenverbrauchsdaten)",
        "menu_66": "Datenverbrauch kaufen",
        "menu_67": "Meine Kapazität",
        "menu_68": "Meine Geräte",
        "menu_69": "Bestelldetails",
        "menu_70": "Anzeigen (Aufladen)",
        "menu_71": "Anzeigen (gekaufte Vorlagen)",
        "menu_72": "Anzeigen (gekaufter Datenverbrauch)",
        "menu_73": "Andere Berechtigungen",
        "menu_74": "Anzeigen (Material- und Programmstatistiken)",
        "menu_75": "Anzeigen (Vermögenswerte)",
        "menu_76": "Anzeigen (Cloud-Datenverbrauch/Statistiken)",
        "menu_77": "Anzeigen (Online-Gerätestatistiken)"
    },
    login: {
        terminalServiceSystem: 'Intelligentes Terminaldienstesystem',
        accountLogin: 'Account-Login',
        register: 'Registrieren',
        accountLoginTip: 'Login mit bestehendem Account',
        scanQRCode: 'Bitte scannen Sie den QR-Code',
        readAndAgree: 'Ich habe gelesen und stimme zu',
        readAndAgreeLink: 'Nutzungsbedingungen',
        readAndAgreeAgreement: 'Bitte lesen und stimmen Sie den Nutzungsbedingungen zu',
        forgetpassword: "Passwort vergessen?",
        resetpassword: "Passwort zurücksetzen",
        phoneEmptyTip: "Bitte geben Sie Ihre Telefonnummer ein",
        nextStep: "Nächster Schritt",
        title: 'Willkommen beim Login',
        submit: 'Anmelden',
        userName: 'Account',
        password: 'Passwort',
        userNameEmptyTip: 'Bitte geben Sie den Account ein',
        passwordEmptyTip: 'Bitte geben Sie das Passwort ein',
        passwordFormatTip: 'Bitte geben Sie das Passwort im korrekten Format ein',
        passwordIsOk: 'Bitte geben Sie das Bestätigungspasswort ein',
        passwordSign: 'Bitte geben Sie das Passwort ein',
        codeTip: "Bitte geben Sie den Bestätigungscode ein",
        phone: "Telefonnummer darf nicht leer sein",
        code: "Bestätigungscode darf nicht leer sein",
        nickname: "Firmenname darf nicht leer sein",
        pass: "Passwort darf nicht leer sein",
        pwdMessage: "Das Passwort muss 8 bis 20 Zeichen lang sein, keine Leerzeichen enthalten und mindestens 3 der folgenden Typen umfassen: Großbuchstaben, Kleinbuchstaben, Zahlen, Sonderzeichen",
        pwdMessage01: "Bitte geben Sie ein Passwort mit Buchstaben und Zahlen und mindestens 8 Zeichen ein",
        pwdMessage02: "Das Passwort muss 8 bis 20 Zeichen lang sein",
        pwdMessage03: "Das Passwort darf keine Leerzeichen enthalten",
        pwdMessage04: "Das Passwort muss mindestens 3 der folgenden Typen umfassen: Großbuchstaben, Kleinbuchstaben, Zahlen, Symbole",
        newpassempty: "Neues Passwort darf nicht leer sein",
        newpass: "Die beiden Passwörter stimmen nicht überein",
        getcode: "Bestätigungscode abrufen",
        format: "Ungültiges Telefonnummernformat",
        chongfa: "Erneutes Senden nach Sekunden",
        isSend: 'Gesendet',
        noregister: "Keinen Account? Jetzt registrieren",
        Mobile: "Telefonnummer",
        verificationcode: "Bestätigungscode",
        petname: "Spitzname",
        Quickregistration: "Schnellregistrierung",
        xiugaimima: "Passwort ändern",
        jiumima: "Altes Passwort",
        xinmima: "Neues Passwort",
        zaicishuruxinmima: "Neues Passwort erneut eingeben",
        xiugaichenggong: "Änderung erfolgreich",
        xiugaishoujihao: "Telefonnummer ändern",
        dengluzhanghao: "Login-Account",
        gongsiid: "Firmen-ID",
        yonghunicheng: "Benutzernickname",
        chuangjianshijian: "Erstellungszeit",
        gongsimingcheng: "Firmenname",
        denglumima: "Login-Passwort",
        jianyi: "Es wird empfohlen, ein Passwort aus Buchstaben und Zahlen zu verwenden",
        shezhimima: "Passwort einstellen",
        shezhishoujihao: "Telefonnummer ändern/einstellen",
        yibangding: "Verknüpft",
        weibangding: "Nicht verknüpft",
        zhanghuanquan: "Kontosicherheit",
        yonghuxinxi: "Benutzerinformationen",
        zhuceSucMsg: 'Herzlichen Glückwunsch, die Registrierung war erfolgreich!',
        verificationcodeSucMsg: "Bestätigungscode wurde erfolgreich gesendet！",
        requiredIsEmpty: "Pflichtfelder dürfen nicht leer sein！",
        emailObj: {
            title: 'E-Mail',
            tit: 'E-Mail-Login',
            tip: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
            formatTip: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        },
        phoneObj: {
            title: 'Telefonnummer',
            tit: 'Telefon-Login',
            tip: 'Bitte geben Sie Ihre Telefonnummer ein',
            formatTip: 'Bitte geben Sie eine gültige Telefonnummer ein',
        },
        emailOrPhoneObj: {
            title: 'E-Mail oder Telefonnummer',
            tit: 'Login mit E-Mail oder Telefonnummer',
            tip: 'Bitte geben Sie Ihre E-Mail oder Telefonnummer ein',
            formatTip: 'Bitte geben Sie eine gültige E-Mail oder Telefonnummer ein',
        },
        wechatObj: {
            title: 'WeChat',
            tit: 'WeChat-Login',
        },
        googleObj: {
            title: 'Google',
            tit: 'Google-Login',
        },
        confirm: 'Bestätigen',
        confirmSubmit: 'Einsenden bestätigen',
        cancel: 'Abbrechen',
        close: 'Schließen',
        bindSucMsg: 'Verknüpfung erfolgreich',
        toContinueBindAccount: 'Fortfahren, um die Verknüpfung des Drittanbieter-Accounts abzuschließen',
        bindTip01: 'Keinen Account? Einen erstellen',
        bindTip02: 'Account bereits vorhanden',
        bindTip03: 'Der aktuelle Drittanbieter-Account ist mit keinem Plattformaccount verknüpft. Bitte verknüpfen Sie einen vorhandenen Account oder registrieren und verknüpfen Sie einen neuen Account, um bei nächstem Mal schnell anzumelden.',
        bindTip04: 'Vorhandenen Account verknüpfen',
        bindTip05: 'Neuen Account registrieren und verknüpfen',
        bindTip06: 'Sie haben die Drittanbieter-Autorisierung abgeschlossen. Vervollständigen Sie die folgenden Login-Informationen, um die Verknüpfung abzuschließen',
        bindSubmit: 'Verknüpfung einsenden',
        enterAccountTip: 'Bitte geben Sie den Accountnamen ein',
        RegisterAndBind: 'Registrieren und verknüpfen',
        loginErr: 'Benutzername oder Passwort falsch！',
        usercenter: "Benutzerzentrum",
        pleaseInputName: "Bitte geben Sie den Namen ein",
        operationSuccess: "Operation erfolgreich！",
        edit: "Bearbeiten",
        xiugai: "Ändern",
        userData: "Persönliche Daten",
        changePassword: "Passwort ändern",
        account: "Account",
        userName01: "Benutzername",
        phoneNumber: "Telefonnummer",
        role: "Rolle",
        createTime: "Erstellungszeit",
        genghuang: "Ersetzen",
        bangding: "Verknüpfen",
        unbind: "Verknüpfung aufheben",
        plesaseSelectBindingType: "Bitte wählen Sie den Verknüpfungstyp",
        pleaseConfirmCont: "Bitte bestätigen Sie, dass Sie diesen Inhalt gelesen haben",
        confirmReadCont: "Ich habe diesen Inhalt gelesen",
        frequentTip: "Zu häufige Operationen, bitte versuchen Sie es später erneut!",
        zhuxiaoBtn: "Account kündigen",
        zhuxiaoTitle: "Account-Kündigung",
        querenZhuxiao: "Kündigung bestätigen",
        jiXu: "Fortfahren",
        sendCodeBtn: "Bestätigungscode senden",
        passwordIsNotOldPassword: "Bestätigungspasswort stimmt nicht mit dem neuen Passwort überein",
        passwordIsOldPassword: "Das neue Passwort ist identisch mit dem alten Passwort",
        passFormatError: "Bitte geben Sie das Passwort im korrekten Format ein",
        oldPassWord: "Altes Passwort",
        newPassWord: "Neues Passwort",
        inputPlaceholder: 'Bitte eingeben',
        confirmPassword: "Passwort bestätigen",
        zhuxiaoTip: `
            1. Die Account-Kündigung ist eine unwiderrufliche Operation. Sobald der Account gekündigt ist, können Sie sich nicht mehr damit anmelden oder ihn nutzen, ebenso nicht Drittanbieter-Accounts, die über diesen Account registriert oder angemeldet wurden. Bitte sichern Sie alle relevanten Account-Informationen und -Daten selbstständig.
            2. Vor der Registrierung dieses Accounts stellen Sie bitte sicher, dass alle Assets geleert wurden und keine Streitigkeiten bestehen. Mit der Kündigung des Accounts verzichten Sie auf das Eigentum an allen Assets und Rechten in diesem Account, und diese können nicht wiederhergestellt oder abgerufen werden.
            3. Wenn ein Account, der mit derselben Telefonnummer registriert wurde, insgesamt 3 Mal gekündigt wurde, kann diese Telefonnummer keinen neuen Account mehr registrieren und auch keinen anderen Account mehr verknüpfen.
            `
    },
    home: {
        title: "Startseite",
        quickOperation: "Schnelloperationen",
        addDevice: "Gerät hinzufügen",
        publishProgram: "Programm veröffentlichen",
        publishMaterial: "Material veröffentlichen",
        makeProgram: "Programm erstellen",
        uploadMaterial: "Material hochladen",
        todayData: "Heutige Daten (stündlich aktualisiert)",
        playNumChart: "Statistik der Wiedergabeanzahl",
        deviceOnlineStatus: "Online-Status der Geräte",
        onLineDevice: "Online-Geräte",
        unLineDevice: "Offline-Geräte",
        programPlayTime: "Statistik der Programm-Wiedergabedauer",
        downloadSoft: "Software downloaden",
        adminApp: "Mobile Benutzerapp",
        playerApp: "Informationsveröffentlichungs-Wiedergabeterminal",
        downloadAdminApp: "Klicken Sie zum Download der Benutzerapp",
        downloadPlayerApp: "Klicken Sie zum Download der Wiedergabeapp",
        aboutUs: "Über uns",
        userManual: "Benutzerhandbuch",
        message: "Nachricht hinterlassen",
    },
    device: {
        inputPlaceholder: 'Bitte eingeben',
        selectPlaceholder: 'Bitte auswählen',
        osTypeStr: 'Terminalsystem',
        onLineStatus: 'Online-Status',
        dpi: 'Auflösung',
        companyDeptIdName: 'Zugehörige Organisation',
        deviceGroupIdName: 'Zugehörige Gruppe',
        editOrMove: 'Bearbeiten/Verschieben',
        loanOriginationFee: 'Kreditbearbeitungsgebühr',
        strategyInfoLook: 'Strategieinformationen anzeigen',
        programLook: 'Programme anzeigen',
        addEquipments: 'Geräte hinzufügen',
        luminanceSet: 'Helligkeitssteuerung',
        terminal: 'Terminaleinstellungen',
        transferCompany: 'Abteilung wechseln',
        releasedProgram: 'Programm veröffentlichen',
        screenshot: 'Bildschirmfoto',
        changeGroup: 'Gruppe ändern',
        defaultGroup: "Standardgruppe",
        operation: "Operationen",
        edit: "Bearbeiten",
        saveEdit: "Bearbeitung speichern",
        add: "Hinzufügen",
        save: "Speichern",
        setting: "Einstellungen",
        program: "Programm",
        unbind: "Verknüpfung aufheben",
        sleep: "Schlafmodus",
        wakeup: "Aufwecken",
        restart: "Neustart",
        shutdown: "Herunterfahren",
        reportLog: "Protokoll melden",
        clearPlayData: "Wiedergabedaten löschen",
        offlineWarn: "Dieses Gerät ist offline. Bitte versuchen Sie es erneut, sobald das Gerät online ist!",
        confirmUnbind: "Verknüpfung wirklich aufheben",
        confirmReset: "Löschen wirklich bestätigen",
        confirmDelete: "Löschen wirklich bestätigen",
        delete: "Löschen",
        cancelDelete: "Löschen abbrechen",
        confirmResetSuccess: "Löschen erfolgreich",
        confirm: "Bestätigen",
        cancel: "Abbrechen",
        operationSuccess: "Operation erfolgreich",
        unbindSuccess: "Verknüpfung erfolgreich aufgehoben",
        pleaseSelectDevice: "Bitte wählen Sie ein Gerät",
        pleaseSelectOnlineDevice: "Bitte wählen Sie ein online-Gerät",
        confirmMixOperation: "Die ausgewählten Geräte umfassen offline-Geräte. Diese Einstellung wirkt sich nicht auf offline-Geräte aus. Fortfahren bestätigen?",
        pleaseSelectDate: "Bitte wählen Sie ein Datum",
        reportSuccess: "Meldung erfolgreich",
        deviceSetting: "Geräteeinstellungen",
        default: "Standard",
        all: "Alle",
        deviceList: "Geräteliste",
        addDevice: "Gerät hinzufügen",
        department: "Abteilungsorganisation",
        deviceType: "Auflösung",
        osType: "Terminalsystem",
        onlineState: "Online-Status",
        online: "Online",
        offline: "Offline",
        notActive: "Nicht aktiviert",
        search: "Bitte geben Sie Schlüsselwörter ein",
        batchOperation: "Stapeloperationen",
        allDevices: "Alle Geräte",
        deviceAttribute: "Geräteattribute",
        selectReportDate: "Meldedatum auswählen",
        inputName: "Bitte geben Sie den Namen ein",
        inputWidth: "Bitte geben Sie die Breite ein",
        inputHeight: "Bitte geben Sie die Höhe ein",
        inputResolutionRatio: "Bitte geben Sie eine ganze Zahl größer als 0 ein!",
        inputSort: "Bitte geben Sie die Sortierung ein",
        serialNum: "Seriennummer",
        name: "Name",
        width: "Breite",
        height: "Höhe",
        resolutionRatio: "Auflösung",
        inputResolutionRatioName: "Bitte geben Sie den Auflösungsnamen ein",
        sort: "Sortierung",
        personal: "Persönlich",
        system: "System",
        type: "Typ",
        systemDefaultSettingUneditable: "Systemstandardeinstellungen können nicht bearbeitet werden!",
        systemDefaultSettingUnDeletable: "Systemstandardeinstellungen können nicht gelöscht werden!",
        newz: "Neu hinzufügen",
        total: "Gesamt",
        totalNum: "Einträge",
        strategyName: "Strategiename",
        associatedTerminalNum: "Anzahl der verknüpften Terminals",
        createTime: "Erstellungszeit",
        pleaseSelectStrategy: "Bitte wählen Sie eine Strategie!",
        onlySelectOneData: "Nur einen Datensatz auswählen!",
        downloadStrategy: "Strategie herunterladen",
        inputStrategyName: "Bitte geben Sie den Strategienamen ein",
        luminanceControl: "Helligkeitssteuerung",
        volumeStrategy: "Lautstärkestrategie",
        saveSuccess: "Speichern erfolgreich",
        screenAngle: "Bildschirmrotation (°)",
        startTime: "Startzeit",
        endTime: "Endzeit",
        repeat: "Wiederholen",
        monday: "Montag",
        tuesday: "Dienstag",
        wednesday: "Mittwoch",
        thursday: "Donnerstag",
        friday: "Freitag",
        saturday: "Samstag",
        sunday: "Sonntag",
        everyday: "Jeden Tag",
        downloadSpeed: "Downloadgeschwindigkeit",
        inputDownloadSpeed: "Bitte geben Sie die Downloadgeschwindigkeit ein",
        operator: "Operationen",
        pleaseSelectDeleteData: "Bitte wählen Sie die zu löschenden Daten aus!",
        confirmBatchDelete: "Stapellöschung wirklich bestätigen?",
        pleaseInputName: "Bitte geben Sie den Namen ein",
        detailSetting: "Detaileinstellungen",
        weekPlan: "Wochenplan",
        specialDateSetting: "Einstellungen für spezielle Daten",
        weekdayInfo: "Wochentag ist ein Pflichtfeld!",
        volumeInfo: "Lautstärke ist ein Pflichtfeld!",
        timeError: "Fehler bei der Zeitauswahl!",
        editSuccess: "Bearbeitungsoperation erfolgreich!",
        addSuccess: "Hinzufügeoperation erfolgreich!",
        addSpecialPlan: "Spezielle Strategieplanung hinzufügen",
        downloadSpeedInfo: "Downloadgeschwindigkeit: (0 bedeutet Download verboten)",
        pleaseSelectStartTime: "Bitte wählen Sie die Startzeit",
        pleaseSelectEndTime: "Bitte wählen Sie die Endzeit",
        luminanceError: "Bitte geben Sie einen korrekten Helligkeitswert ein!",
        defaultLuminance: "Standardhelligkeit",
        luminance: "Helligkeitsgrad",
        defaultLuminanceInfo: "Standardhelligkeit (100 = maximal hell, 0 = maximal dunkel)",
        volume: "Lautstärke",
        saveLuminance: "Helligkeit speichern",
        changeSuccess: "Änderung erfolgreich!",
        changeNetwork: "Netzwerk wechseln",
        netName: "Netzwerkname",
        nameempty: "Netzwerkname darf nicht leer sein",
        currentNetwork: "Aktuelles Netzwerk",
        ipAddress: "IP-Adresse",
        dailyMode: "Täglicher Modus",
        weeklyMode: "Wöchentlicher Modus",
        turnOnTime: "Einschaltzeit",
        turnOffTime: "Ausschaltzeit",
        startSleep: "Schlafmodus starten",
        endSleep: "Schlafmodus beenden",
        batchDelInfo: "Ausgewählte Einträge wirklich löschen?",
        timeCannotBeEmpty: "Zeit darf nicht leer sein!",
        startUp: "Einschalten",
        shutDown: "Ausschalten",
        volumeSize: "Lautstärkegrad",
        defaultVolume: "Standardlautstärke (100 = maximal laut, 0 = stumm)",
        chooseStartTime: "Bitte wählen Sie die Startzeit",
        chooseEndTime: "Bitte wählen Sie die Endzeit",
        saveVolume: "Lautstärke speichern",
        screenRotationUnSaved: "Bildschirmrotation nicht gespeichert",
        volumeSettingUnSaved: "Lautstärkeeinstellungen nicht gespeichert",
        luminanceSettingUnSaved: "Helligkeitseinstellungen nicht gespeichert",
        confirmClosePopup: "Dieses Popup wirklich schließen?",
        volumeSettingSuccess: "Lautstärkeänderung erfolgreich",
        luminanceSettingSuccess: "Helligkeitsänderung erfolgreich",
        advancedSettingUnSaved: "Erweiterte Einstellungen nicht gespeichert",
        settingTitle: "Terminaleinstellungen",
        volumeSetting: "Lautstärkeeinstellungen",
        luminanceSetting: "Helligkeitseinstellungen",
        downloadSetting: "Downloadeinstellungen",
        sleepSetting: "Schlafmoduseinstellungen",
        onOffSetting: "Zeitgesteuertes Ein-/Ausschalten",
        screenRotation: "Bildschirmrotation",
        namingError: "Namensfehler, Dateiname darf keine Leerzeichen enthalten!",
        deleteSuccess: "Löschen erfolgreich",
        deleteFolder: "Ordner löschen",
        pleaseInputDeviceName: "Bitte geben Sie den Gerätenamen ein",
        pleaseInputDeviceId: "Bitte geben Sie die Geräte-ID ein",
        discoverDevice: "Gerät entdecken",
        deviceId: "Geräte-ID",
        bound: "Verknüpft",
        bind: "Verknüpfen",
        noDevice: "Keine Geräte vorhanden",
        refresh: "Aktualisieren",
        manualAdd: "Manuell hinzufügen",
        deviceGroup: "Gerätekategorie",
        pleaseSelectGroup: "Bitte wählen Sie eine Gruppe!",
        deviceName: "Gerätename",
        goAdd: "Zum Hinzufügen gehen",
        close: "Schließen",
        bindCountInsufficient: "Verfügbare Verknüpfungsanzahl unzureichend. Bitte erweitern Sie die Geräteanzahl vor dem Hinzufügen!",
        displayNumber: "Anzeigenummer",
        groupName: "Gruppenname",
        pleaseSelectGroupName: "Bitte geben Sie den Gruppennamen ein!",
        moveGroup: "Gruppe verschieben",
        longitude: "Längengrad",
        latitude: "Breitengrad",
        nationality: "Nationalität",
        province: "Provinz",
        city: "Stadt",
        county: "Kreis",
        outNetIp: "Externe IP",
        inNetIp: "Interne IP",
        companyName: "Firmenname",
        Info: "Details",
        android: "Android",
        win: "Windows",
        osVersion: "Systemversion",
        softwareVersion: "Softwareversion",
        diskSize: "Festplattengröße",
        useSize: "Verwendete Größe",
        macAddr: "MAC-Adresse",
        longitudeLatitudeInfo: "Längen- und Breitengrad müssen gleichzeitig leer oder gefüllt sein!",
        terminalName: "Terminalname",
        terminalGroup: "Terminalgruppe",
        reportJournal: "Meldung aktivieren",
        systemVersion: "Systemversion",
        storageSpace: "Speicherplatz",
        resolution: "Auflösung",
        runningMemory: "Arbeitsspeicher",
        model: "Modell",
        registerStatus: "Registrierungsstatus",
        password: "Passwort",
        passwordInfo: "Bitte geben Sie 6 bis 18 Buchstaben oder Zahlen ein!",
        group: "Gruppe",
        address: "Adresse",
        remark: "Bemerkungen",
        renewalPeriod: "Erneuerungszeitraum",
        money: "Gebühr",
        latitudeInfo: "Bitte geben Sie einen korrekten Breitengrad ein!",
        totalPayment: "Gesamtbetrag",
        longitudeInfo: "Bitte geben Sie einen korrekten Längengrad ein!",
        setMeal: "Paket",
        number: "Anzahl",
        programName: "Programmname",
        playStatus: "Wiedergabestatus",
        playType: "Wiedergabemodus",
        play: "Wiedergabe",
        pause: "Pause",
        playTime: "Wiedergabezeit",
        programDeleted: "Programm wurde gelöscht",
        playSuccess: "Programm zur Wiedergabe geplant",
        pauseSuccess: "Pause erfolgreich",
        playCycle: "Zyklische Wiedergabe",
        playInsert: "Eingebettete Wiedergabe",
        withdrawSuccess: "Rücknahme erfolgreich",
        withdrawInfo: "Bitte wählen Sie zuerst das zurückzunehmende Programm aus!",
        programBelong: "Zugehöriges Programm",
        checkAll: "Alles auswählen",
        batchDel: "Stapellöschung",
        delConfirm: "Ausgewählte Einträge wirklich löschen?",
        check: "Ausgewählt",
        noProgram: "Keine Programme vorhanden",
        details: "Details",
        screenshotFail: "Bildschirmfoto fehlgeschlagen",
        policyName: "Strategiename",
        terminalNum: "Anzahl der verknüpften Terminals",
        powerStrategy: "Stromstrategie",
        pleaseSelectDepartment: "Bitte wählen Sie eine Abteilung!",
        screenshotControl: "Bildschirmfoto-Steuerung",
        未激活: "Nicht aktiviert",
        已激活: "Aktiviert",
        未绑定: "Nicht verknüpft",
        已绑定: "Verknüpft",
    },
    programManage: {
        programList: "Programmliste",
        publishProgram: "Veröffentlichungsverfolgung von Programmen",
        week1: "Montag",
        week2: "Dienstag",
        week3: "Mittwoch",
        week4: "Donnerstag",
        week5: "Freitag",
        week6: "Samstag",
        week7: "Sonntag",
        monday: "Montag",
        tuesday: "Dienstag",
        wednesday: "Mittwoch",
        thursday: "Donnerstag",
        friday: "Freitag",
        saturday: "Samstag",
        sunday: "Sonntag",
        name: "Name",
        preview: "Vorschau",
        playDeviceNum: "Anzahl der Wiedergabegeräte",
        copyDeviceCode: "Klicken zum Kopieren",
        osType: "Systemtyp",
        playDate: "Wiedergabedatum",
        playWeek: "Wiedergabewoche",
        everyday: "Jeden Tag",
        start: "Von",
        end: "Bis",
        playOperateStatusStr: "Veröffentlichungsstatus",
        playDevice: "Wiedergabegerät",
        downloadView: "Download anzeigen",
        publisher: "Veröffentlicher",
        publishTime: "Veröffentlichungszeit",
        operation: "Operationen",
        add: "Hinzufügen",
        groupName: "Gruppenname",
        selectDevice: "Terminal auswählen",
        searchDevice: "Terminal suchen",
        pleaseFillGroupName: "Bitte geben Sie den Gruppennamen ein!",
        remarkInfo: "Bemerkungen",
        compile: "Bearbeiten",
        withdrawConfirm: "Dieses Programm wirklich zurücknehmen?",
        confirm: "Bestätigen",
        cancel: "Abbrechen",
        withdraw: "Zurücknehmen",
        batchWithdraw: "Stapelrücknahme",
        batchPublish: "Stapelveröffentlichung",
        batchDelete: "Stapellöschung",
        batchOperation: "Stapeloperationen",
        notUse: "Nicht verwendet",
        notChecked: "Nicht geprüft",
        notPass: "Nicht genehmigt",
        delete: "Löschen",
        publishTextLeft: "Veröffentlicht",
        offTextLeft: "Pausiert",
        pleaseSelectProgramToMove: "Bitte wählen Sie das zu verschiebende Programm aus!",
        pause: "Pause",
        pauseConfirm: "Pause wirklich bestätigen?",
        play: "Wiedergabe",
        downloadUdisk: "Auf USB-Stick herunterladen",
        deviceList: "Geräteliste",
        groupSelection: "Gruppenauswahl",
        operationSuccess: "Operation erfolgreich",
        deleteSuccess: "Löschen erfolgreich",
        selectDate: "Datum auswählen",
        publishStatus: "Veröffentlichungsstatus",
        checkStatus: "Prüfungsstatus",
        waitAuditing: "In Prüfung",
        auditPass: "Prüfung bestanden",
        auditRefuse: "Prüfung abgelehnt",
        all: "Alle",
        playStatus: "Wiedergabe läuft",
        playStatust: "Wiedergabestatus",
        pauseStatus: "Pausiert",
        notStartStatus: "Nicht gestartet",
        resolutionratio: "Auflösung",
        totalNum: "Einträge",
        programName: "Programmname",
        playStartTime: "Startzeit der Wiedergabe",
        playEndTime: "Endzeit der Wiedergabe",
        createTime: "Erstellungszeit",
        nationality: "Nationalität",
        province: "Provinz",
        city: "Stadt",
        county: "Kreis/Bezirk",
        address: "Adresse",
        ip: "IP-Adresse",
        location: "Standort",
        log: "Protokoll",
        pleaseFillProgramName: "Bitte geben Sie den Programmnamen ein!",
        selectGroup: "Gruppe auswählen",
        startTime: "Startzeit",
        endTime: "Endzeit",
        publishCycle: "Veröffentlichungszyklus",
        publishDeviceNum: "Anzahl der veröffentlichten Geräte",
        pleaseSelectRecord: "Bitte wählen Sie einen Datensatz aus",
        deviceName: "Terminalname",
        deviceId: "Terminalgeräte-ID",
        deviceGroupIdName: "Zugehörige Gruppe",
        notClassified: "Nicht klassifiziert",
        osTypeStr: "Terminalsystem",
        storageSpace: "Speicherplatz",
        onLineStatus: "Online-Status",
        onLine: "Online",
        offLine: "Offline",
        sleep: "Schlafmodus",
        unknown: "Unbekannt",
        registerStatus: "Registrierungsstatus",
        trialPeriod: "Testphase",
        notActive: "Nicht aktiviert",
        active: "Aktiviert",
        parameterError: "Parameter fehlerhaft!",
        pleaseSelectProgram: "Bitte wählen Sie ein Programm!",
        pleaseSelectProgramEdit: "Bitte wählen Sie das zu bearbeitende Programm aus!",
        confirmWithdrawSelectedProgram: "Ausgewählte Programme wirklich zurücknehmen?",
        withdrawSuccess: "Rücknahme erfolgreich",
        allPrograms: "Alle Programme",
        defaultGroup: "Standardgruppe",
        cannotShareEmptyProgram: "Leere Programme können nicht geteilt werden!",
        onlyShareYourProgram: "Sie können nur Programme teilen, die Sie erstellt haben!",
        pleaseSelectProgramEditPublishTime: "Bitte wählen Sie das Programm mit bearbeiteter Veröffentlichungszeit aus!",
        pleaseSelectDevice: "Bitte wählen Sie ein Gerät!",
        programDetail: "Programmdetails",
        errorReason: "Fehlerursache",
        availableStorageSpaceInsufficient: "Verfügbarer Speicherplatz unzureichend",
        partialDeviceReleaseFailure: "Veröffentlichung auf einigen Geräten fehlgeschlagen",
        allDeviceReleaseSuccess: "Veröffentlichung auf allen Geräten erfolgreich",
        partialDeviceReleaseSuccess: "Veröffentlichung auf einigen Geräten erfolgreich",
        allGroup: "Alle Gruppen",
        allProgram: "Alle Programme",
        unGrouped: "Nicht gruppiert",
        replaceProgram: "Programm ersetzen",
        replaceProgramTip: "Das neu veröffentlichte Programm ersetzt die bestehenden Programm Daten auf dem Wiedergabeterminal!",
        screen: "Einzel-/Doppelbildschirm",
        singleScreen: "Einzelbildschirm",
        doubleScreen: "Doppelbildschirm",
        playSetting: "Wiedergabeeinstellungen",
        batchPlaySetting: "Stapelweise Einstellung der Wiedergabezeit",
        individualPlaySetting: "Einzelne Einstellung der Wiedergabezeit",
        playTime: "Wiedergabezeit",
        daily: "Täglich",
        weekdays: "Montag bis Freitag",
        monthly: "Dieser Monat",
        advancedSetting: "Erweiterte Einstellungen",
        playProgram: "Programm abspielen",
        searchProgram: "Bitte geben Sie Schlüsselwörter ein",
        shareAddressNotExist: "Link-Adresse existiert nicht, bitte versuchen Sie es erneut",
        copySuccess: "Kopieren erfolgreich",
        shareLink: "Teilen-Link",
        publish: "Veröffentlichen",
        noResource: "Keine Ressourcen vorhanden",
        single: "Einzelbildschirm",
        double: "Doppelbildschirm",
        time: "Zeit",
        associatedTerminalNum: "Anzahl der verknüpften Terminals",
        default: "Standard",
        moveGroup: "Gruppe verschieben",
        pleaseSelectGroup: "Bitte geben Sie den Gruppennamen ein!",
        copy: "Kopieren",
        FUBEN: "Kopie",
        nameempty: "Name darf nicht leer sein",
        whitespace: "Namensfehler, Dateiname darf keine Leerzeichen enthalten!",
        programWhitespace: "Namensfehler, Programmname darf keine Leerzeichen enthalten!",
        pleaseSelectResolution: "Bitte wählen Sie eine Auflösung!",
        dataError: "Daten fehlerhaft!",
        createProgram: "Neues Programm erstellen",
        directCreate: "Direkt erstellen",
        myTemplate: "Meine Vorlagen",
        use: "Verwenden",
        free: "Kostenlos",
        loadMore: "Mehr laden",
        confirmDelete: "Löschen bestätigen",
        deleteGroup: "Gruppe löschen",
        notPublished: "Nicht veröffentlicht",
        notPassed: "Nicht bestanden",
        notUsed: "Nicht verwendet",
        confirmDeleteSelectedProgram: "Ausgewählte Programme wirklich löschen?",
        companyName: "Firmenname",
        programCannotDownload: "Dieses Programm kann nicht heruntergeladen werden!",
        publishMaterial: "Material veröffentlichen",
        playMaterial: "Material abspielen",
        pleaseInputMaterialName: "Bitte geben Sie den Materialnamen ein",
        size: "Größe",
        pleaseInputDeviceName: "Bitte geben Sie den Gerätenamen ein",
        item: "Einträge",
        allMaterial: "Alle Materialien",
        allDevices: "Alle Geräte",
        "saveSuccess": "Erfolgreich gespeichert",
        "savefaill": "Speichern fehlgeschlagen",
        "playMode": "Wiedergabemodus",
        "cyclePlay": "Zyklische Wiedergabe",
        "insertPlay": "Eingebettete Wiedergabe",
        "noData": "Keine Daten vorhanden",
        "Add": "Hinzufügen",
        "replace": "Ersetzen",
        "repeat": "Wiederholen",
        "start01": "Start",
        "end01": "Ende",
        "startDate": "Startdatum",
        "endDate": "Enddatum",
        "useNow": "Sofort verwenden",
        "fillStartEndTimeFirst": "Bitte füllen Sie zuerst Start- und Endzeit aus, bevor Sie hinzufügen",
        "fillFullPlayTime": "Bitte füllen Sie die vollständige Wiedergabezeit aus",
        "fillCorrectPlayTime": "Bitte füllen Sie den korrekten Wiedergabezeitraum aus",
        "sDateAndEDateBothEmptyOrFilled": "Startdatum und Enddatum müssen beide leer oder beide ausgefüllt sein"
    },
    source: {
        addResource: "Ressource hinzufügen",
        width: "Breite",
        height: "Höhe",
        size: "Größe (KB)",
        name: "Name",
        pleaseInputResourceName: "Bitte geben Sie den Ressourcennamen ein!",
        addToGroup: "Zu Gruppe hinzufügen",
        remark: "Bemerkungen",
        promptFgIllustrate: "Illustration",
        promptFgRealisticPhoto: "Realistisches Foto",
        promptFgSimplisticDrawing: "Einfache Zeichnung",
        promptFgChineseStyle: "Chinesischer Stil",
        promptFgPixelArt: "Pixel-Art",
        noModel: "Keine Modelle vorhanden, bitte kontaktieren Sie den Administrator!",
        getModelFailed: "Abrufen der Modelle fehlgeschlagen, bitte versuchen Sie es später erneut! Oder kontaktieren Sie den Administrator!",
        createImagePrompt: "Bild wird generiert, bitte schließen Sie das Fenster nicht!",
        promptEmpty: "Bitte geben Sie ein Prompt-Wort ein",
        dpiEmpty: "Bitte wählen Sie das Bildverhältnis aus!",
        fgEmpty: "Bitte wählen Sie einen Stil aus!",
        style: "Stil",
        idEmpty: "Bild-ID darf nicht leer sein",
        exist: "Dieses Bild existiert bereits im Material",
        addSuccess: "Material erfolgreich hinzugefügt",
        saveError: "Speichern des Bildes fehlgeschlagen, bitte versuchen Sie es später erneut!",
        delSuccess: "Löschen erfolgreich",
        generateImage: "Text zu Bild",
        generateImagePlaceholder: 'Bitte geben Sie das Bild ein, das Sie generieren möchten, z.B.: Ein Schmetterling tanzt in einer Blumenwiese',
        aiExpand: "Intelligente Erweiterung",
        negativePrompt: "Negatives Prompt-Wort",
        negativePromptTooltip: "Wird verwendet, um Inhalte oder Merkmale explizit auszuschließen, die der Benutzer nicht in der Ausgabe sehen möchte",
        imageRatio: "Bildverhältnis",
        generateImageBtn: "Sofort generieren",
        shengchengjieguo: "Generierungsergebnis",
        generateImageLoadingTip: "Generierung läuft, bitte nicht mehrmals klicken oder schließen...",
        Tooltip: "Bringe deine Kreativität mit KI zum Leben",
        saveToMaterial: "Zu Material speichern",
        publish: "Sofort veröffentlichen",
        download: "Herunterladen",
        generateHistory: "Generierungsverlauf",
        hide: "Einklappen",
        cancel: "Abbrechen",
        useExpand: "Erweiterung verwenden",
        all: "Alle",
        delete: "Löschen",
        loadMore: "Mehr laden",
        aiTip: "Der Inhalt wird von einem künstlichen Intelligenz-Modell generiert und spiegelt nicht die Ansichten, Positionen oder Haltungen der Plattform wider. Bitte verwenden Sie den KI-Inhalt rechtmäßig und konform.",
        operationSuccess: "Operation erfolgreich",
        moveGroup: "Gruppe verschieben",
        groupName: "Gruppenname",
        pleaseSelectGroup: "Bitte wählen Sie den Gruppennamen aus!",
        shenhe: "Prüfung",
        shenheStatus: "Prüfungsstatus",
        shenheSuccess: "Prüfung bestanden",
        shenheRefuse: "Prüfung abgelehnt",
        pleaseSelectShenheStatus: "Bitte wählen Sie den Prüfungsstatus aus!",
        shenheRemark: "Prüfungsbemerkungen",
        pleaseInputShenheRemark: "Bitte geben Sie die Prüfungsbemerkungen ein!",
        pleaseInputFileName: "Bitte geben Sie den Dateinamen ein!",
        whitespace: "Namensfehler, Dateiname darf keine Leerzeichen enthalten!",
        dataError: "Daten fehlerhaft!",
        confirmDelete: "Löschen bestätigen",
        confirm: "Bestätigen",
        deleteFolder: "Ordner löschen",
        add: "Hinzufügen",
        edit: "Bearbeiten",
        fileName: "Dateiname",
        group: "Gruppe",
        resolution: "Auflösung",
        type: "Typ",
        image: "Bild",
        music: "Musik",
        video: "Video",
        uploadTime: "Upload-Zeit",
        uploadUser: "Uploader",
        checkTime: "Prüfungszeit",
        checkUser: "Prüfer",
    },
    "setting": {
        "nameempty": "Der Name darf nicht leer sein",
        "heightempty": "Die Höhe darf nicht leer sein",
        "widthempty": "Die Breite darf nicht leer sein",
        "resolutionratio": "Auflösung",
        "name": "Name",
        "opteration": "Operation",
        "compile": "Bearbeiten",
        "delete": "Löschen",
        "newz": "Hinzufügen",
        "compileratio": "Auflösung bearbeiten",
        "sheizhifenbianlvmingcheng": "Auflösungsnamen festlegen",
        "shezhigaodu": "Höhe festlegen",
        "shezhikuandu": "Breite festlegen",
        "xinzengfenbianlv": "Auflösung hinzufügen",
        "bianma": "Codierung",
        "bianjizhongduanmingcheng": "Endgerätename bearbeiten",
        "xinzengzhongduan": "Endgerät hinzufügen",
        "selectPrimaryColor": "Themenfarbe auswählen",
        "fullScreen": "Vollbild",
        "exitFullScreen": "Vollbild verlassen"
    },
    "tabs": {
        "refresh": "Aktualisieren",
        "refreshAll": "Alle aktualisieren",
        "close": "Schließen",
        "closeOthers": "Andere schließen",
        "closeAll": "Alle schließen",
        "closeLeft": "Linke schließen",
        "closeRight": "Rechte schließen"
    },
    "errorPage": {
        "needLogin": "Sie sind noch nicht angemeldet!",
        "pageNotFound": "Die aufgerufene Seite existiert nicht!",
        "redirectTo": "Weiterleiten zu",
        "orReturn": "oder zurückkehren zu",
        "previousStep": "Vorheriger Schritt"
    },
    "headerUs": {
        "systemNotice": "Systembenachrichtigung",
        "allNotices": "Alle Benachrichtigungen",
        "viewAllMessages": "Alle Nachrichten anzeigen",
        "contactUs": "Kontaktieren Sie uns",
        "operationSuccess": "Operation erfolgreich!",
        "leaveMessage": "Nachricht hinterlassen",
        "messageTitle": "Titel",
        "messageTitleTip": "Bitte geben Sie einen Titel ein!",
        "messageContentTip": "Max. 150 Zeichen",
        "submit": "Einreichen",
        "markAsRead": "Als gelesen markieren",
        "success": "Operation erfolgreich!"
    },
    "material": {
        "allMaterial": "Alle Materialien",
        "defaultGroup": "Standardgruppe",
        "auditStatus": "Prüfstatus",
        "auditPassed": "Genehmigt",
        "auditRejected": "Abgelehnt",
        "pendingAudit": "Zur Prüfung anstehend",
        "all": "Alle",
        "operateSuccess": "Operation erfolgreich!",
        "pleaseSelectMaterial": "Bitte wählen Sie Materialien aus!",
        "moveGroup": "In Gruppe verschieben",
        "pleaseSelectGroup": "Bitte wählen Sie eine Gruppe aus!",
        "batchPublish": "Batch-Veröffentlichung",
        "batchRecall": "Batch-Rücknahme",
        "batchDelete": "Batch-Löschung",
        "materialList": "Materialienliste",
        "uploadMaterial": "Material hochladen",
        "materialType": "Materialtyp",
        "pleaseInputMaterialName": "Bitte geben Sie einen Materialnamen ein",
        "selectAll": "Alles auswählen",
        "confirmDeleteSelectedMaterial": "Möchten Sie die ausgewählten Materialien wirklich löschen?",
        "deleteSuccess": "Löschen erfolgreich",
        "delete": "Löschen",
        "publish": "Veröffentlichen",
        "recall": "Zurückziehen",
        "confirmRecallSelectedMaterial": "Möchten Sie die ausgewählten Materialien wirklich zurückziehen?",
        "pleaseSelectMaterialGroup": "Bitte wählen Sie eine Materialgruppe aus!",
        "recallSuccess": "Rücknahme erfolgreich",
        "publishSuccess": "Veröffentlichung erfolgreich",
        "batchOperate": "Batch-Operation",
        "item": "Stück",
        "confirmDelete": "Möchten Sie wirklich löschen?",
        "edit": "Bearbeiten",
        "confirmRecall": "Möchten Sie wirklich zurückziehen?",
        "unaudited": "Nicht geprüft",
        "notPassed": "Nicht bestanden",
        "operate": "Operation",
        "resolution": "Auflösung",
        "none": "Keine",
        "confirm": "Bestätigen",
        "cancel": "Abbrechen",
        "AICreation": "KI-Erstellung"
    },
    "uploadFile": {
        "operationSuccess": "Operation erfolgreich",
        "uploadFile": "Upload-Verwaltung",
        "uploadSuccess": "Upload erfolgreich",
        "uploadCompleted": "Upload abgeschlossen",
        "uploadFail": "Upload fehlgeschlagen",
        "ConversionFailed": "Konvertierung fehlgeschlagen!",
        "loading": "Laden läuft...",
        "beQueuing": "In Warteschlange...",
        "Uploading": "Wird hochgeladen...",
        "ConversionIng": "Wird konvertiert...",
        "ConventionalResources": "Standardressourcen",
        "DocumentResources": "Dokumentressourcen",
        "complete": "Abgeschlossen",
        "upload": "Hochladen",
        "fileSizeWraning01": "Materialgröße überschreitet",
        "fileSizeWraning02": "Bitte bearbeiten und erneut hochladen!",
        "fileIsEmpty": "Datei ist leer",
        "uploadFileTip": "Nicht unterstützter Dateiformat",
        "unablePreview": "Nicht erfolgreich zur Materialbibliothek hinzugefügt, Vorschau nicht möglich",
        "confirmDelete": "Möchten Sie wirklich löschen?",
        "deleteSuccess": "Löschen erfolgreich",
        "delete": "Löschen",
        "confirm": "Bestätigen",
        "preview": "Vorschau",
        "close": "Schließen",
        "cancel": "Abbrechen",
        "fileType": "Dateityp",
        "fileSize": "Dateigröße",
        "conversionProgress": "Konvertierungsfortschritt",
        "progress": "Fortschritt",
        "image": "Bild",
        "video": "Video",
        "audio": "Musik",
        "limitTip01": "Einmal hochladen",
        "limitTip02": "Dateien",
        "okTip": "Material wird hochgeladen, bitte schließen Sie das Fenster nicht vor Abschluss!",
        "usableSize": "Verfügbarer Speicherplatz",
        "sizeUnableTip": "Der aktuelle verfügbare Speicherplatz ist unzureichend. Bitte bereinigen Sie ungenutzte Materialien rechtzeitig, um Speicherplatz freizugeben, oder kontaktieren Sie Ihren Händler, um den Speicherplatz der Cloud-Speicher zu erweitern. Dieser Service kann Kosten verursachen, genaue Informationen entnehmen Sie bitte bei Ihrem Händler.",
        "view": "Details anzeigen",
        "fileName": "Dateiname"
    },
    "template": {
        "inputPlaceholder": "Bitte eingeben",
        "selectPlaceholder": "Bitte auswählen",
        "noAuths": "Keine Berechtigungen, bitte kontaktieren Sie den Administrator",
        "operationSuccess": "Operation erfolgreich",
        "total": "Gesamt",
        "totalNum": "Stück",
        "dan": "Einzel",
        "shaung": "Doppel",
        "pleaseSelectGroup": "Bitte wählen Sie eine Gruppe aus",
        "preview": "Vorschau",
        "free": "Kostenlos",
        "use": "Verwenden",
        "dpi": "Auflösung",
        "delete": "Löschen",
        "confirmDelete": "Löschen bestätigen",
        "confirmDeleteSelectedTemplate": "Möchten Sie diese Vorlage wirklich löschen?",
        "push": "Veröffentlichen",
        "pushConfirm": "Möchten Sie wirklich in die öffentlichen Vorlagen veröffentlichen?",
        "pushRemovalConfirm": "Möchten Sie wirklich aus den öffentlichen Vorlagen entfernen?",
        "templateOrderRecord": "Vorlagenauftragsprotokoll",
        "unpublished": "Nicht veröffentlicht",
        "auditing": "In Prüfung",
        "publishRejected": "Veröffentlichung abgelehnt",
        "publishSuccess": "Veröffentlichung erfolgreich",
        "offShelf": "Aus dem Angebot nehmen",
        "公共模版": "Öffentliche Vorlagen",
        "我的模板": "Meine Vorlagen",
        "共享记录": "Freigabeprotokoll",
        "name": "Name",
        "pubdate": "Veröffentlichungsdatum",
        "keySeachTip": "Bitte geben Sie Schlüsselwörter ein",
        "allGroup": "Alle Gruppen",
        "add": "Hinzufügen",
        "edit": "Bearbeiten",
        "programName": "Programmname",
        "selectGroup": "Gruppe auswählen"
    },
    "checkManage": {
        "total": "Gesamt",
        "totalNum": "Stück",
        "operationSuccess": "Operation erfolgreich",
        "checkUserLogs": "Prüfprotokoll (Betreiber)",
        "checkLogs": "Prüfprotokoll (Prüfer)",
        "sourceCheck": "Materialprüfung",
        "programCheck": "Programmprüfung",
        "checkAll": "Alles auswählen",
        "auditPass": "Prüfung bestanden",
        "auditRefuse": "Prüfung abgelehnt",
        "auditPass01": "Bestanden",
        "auditRefuse01": "Abgelehnt",
        "auditRefuse02": "Prüfung ablehnen",
        "auditor": "Prüfer",
        "agentUserName": "Veröffentlicher",
        "interrogationTime": "Prüfungsantragszeit",
        "checkTime": "Prüfungszeit",
        "checkName": "Prüfungsname",
        "checkType": "Prüfungskategorie",
        "checkIp": "Prüfungs-IP-Adresse",
        "checkReason": "Kommentar",
        "checkStatus": "Operationsinhalt",
        "rangePicker": "Prüfungsdatum",
        "keyWord": "Schlüsselwort",
        "all": "Alle",
        "program": "Programm",
        "material": "Material",
        "dan": "Einzel",
        "shaung": "Doppel",
        "pleaseSelectProgram": "Bitte wählen Sie ein Programm aus!",
        "pleaseSelectMaterial": "Bitte wählen Sie Materialien aus!",
        "preview": "Vorschau",
        "dpi": "Auflösung",
        "auditRefuseTip": "Bitte geben Sie den Ablehnungsgrund ein",
        "unreviewed": "Nicht geprüft",
        "notPassed": "Nicht bestanden",
        "notUsed": "Nicht verwendet",
        "edit": "Bearbeiten",
        "none": "Keine",
        "name": "Name",
        "size": "Größe",
        "type": "Typ",
        "uploadTime": "Upload-Zeit",
        "uploadUser": "Uploader",
        "checkUser": "Prüfer",
        "image": "Bild",
        "music": "Musik",
        "video": "Video"
    },
    "systemSet": {
        "total": "Gesamt",
        "totalNum": "Stück",
        "inputPlaceholder": "Bitte eingeben",
        "selectPlaceholder": "Bitte auswählen",
        "userList": "Organisationsmitglieder",
        "roleList": "Rollenberechtigungen",
        "department": "Organisationsstruktur",
        "diskInfo": "Speicherplatz",
        "approveSet": "Inhaltsgenehmigung",
        "logList": "Protokollverwaltung",
        "name": "Name",
        "account": "Konto",
        "userName": "Benutzername",
        "phoneNumber": "Telefonnummer",
        "role": "Rolle",
        "createTime": "Erstellungszeit",
        "operation": "Operation",
        "edit": "Bearbeiten",
        "delete": "Löschen",
        "addNew": "Hinzufügen",
        "add": "Hinzufügen",
        "resetPassword": "Passwort zurücksetzen",
        "confirmDelete": "Löschen bestätigen",
        "departmentOrganization": "Abteilungsorganisation",
        "addNewUser": "Benutzer hinzufügen",
        "pleaseEnterUserName": "Bitte geben Sie den Benutzernamen ein",
        "confirmPasswordNotMatch": "Bestätigungspasswort stimmt nicht mit dem Passwort überein!",
        "operationSuccess": "Operation erfolgreich!",
        "userNickname": "Benutzername",
        "pleaseEnterUserNickname": "Bitte geben Sie den Benutzernamen ein",
        "userNicknameRequired": "Benutzername darf nicht leer sein!",
        "password": "Passwort",
        "pleaseEnterPassword": "Bitte geben Sie ein Passwort ein",
        "passwordRequired": "Passwort darf nicht leer sein!",
        "passwordTip": "Ihr Passwort ist zu unsicher (Das Passwort muss mindestens 3 der folgenden Elemente enthalten: Großbuchstaben, Kleinbuchstaben, Zahlen, Sonderzeichen und eine Länge von 8",
        "confirmPassword": "Passwort bestätigen",
        "pleaseEnterPhoneNumber": "Bitte geben Sie eine Telefonnummer ein",
        "phoneNumberRequired": "Telefonnummer darf nicht leer sein!",
        "phoneNumberFormatError": "Bitte geben Sie eine gültige Telefonnummer ein!",
        "roleRequired": "Rolle darf nicht leer sein!",
        "required": "Darf nicht leer sein!",
        "departmentName": "Abteilung",
        "modifyPassword": "Passwort ändern",
        "newPassword": "Neues Passwort",
        "pleaseEnterNewPassword": "Bitte geben Sie ein neues Passwort ein",
        "pwdMessage": "Passwortlänge 8~20 Zeichen, keine Leerzeichen und muss mindestens 3 der folgenden Elemente enthalten: Großbuchstaben, Kleinbuchstaben, Zahlen, Sonderzeichen",
        "all": "Alle",
        "noAuths": "Keine Berechtigungen, bitte kontaktieren Sie den Administrator",
        "departmentName01": "Abteilungsname",
        "image": "Bild",
        "music": "Musik",
        "video": "Video",
        "buySize": "Kaufmenge",
        "totalMoney": "Gesamtbetrag",
        "buycreateTime": "Kaufzeit",
        "endTime": "Ablaufzeit",
        "buyTypeStr": "Auftragstyp",
        "sourceCheck": "Materialprüfung",
        "programCheck": "Programmprüfung",
        "programName": "Programmname",
        "diskExpansion": "Es wird empfohlen, abgelaufene/nicht genutzte Materialien rechtzeitig zu bereinigen, um den verfügbaren Speicherplatz des Systems zu gewährleisten. Wenn Sie mehr Speicherplatz benötigen, können Sie sich an Ihren Geräteanbieter wenden, um den Speicherplatz der Cloud-Speicher zu erweitern. Dieser Service kann Kosten verursachen, genaue Informationen entnehmen Sie bitte bei Ihrem Händler.",
        "selectPermission": "Bitte wählen Sie Berechtigungen aus",
        "checkPermission": "Bitte markieren Sie die Berechtigungen",
        "addRole": "Rolle hinzufügen",
        "enterRoleName": "Bitte geben Sie den Rollennamen ein",
        "roleName": "Rollenname",
        "roleNameRequired": "Rollenname darf nicht leer sein!",
        "remark": "Bemerkung",
        "enterRemark": "Bitte geben Sie eine Bemerkung ein",
        "permissionSetting": "Berechtigungseinstellung",
        "deleteSuccess": "Löschen erfolgreich!",
        "confirmToDelete": "Möchten Sie wirklich löschen?",
        "orgName": "Organisationsname",
        "orgNameRequired": "Organisationsname darf nicht leer sein!",
        "orgRemark": "Organisationsbemerkung",
        "enterOrgRemark": "Bitte geben Sie eine Organisationsbemerkung ein",
        "capacityUsage": "Speichernutzung",
        "usedCapacity": "Verwendeter Speicherplatz",
        "totalCapacity": "Gesamtspeicherplatz",
        "remainingCapacity": "Verbleibender Speicherplatz",
        "capacityExpansion": "Speichererweiterung",
        "enable": "Aktivieren",
        "disable": "Deaktivieren",
        "userName01": "Benutzername",
        "loginTime": "Anmeldezeit",
        "ipAddress": "IP-Adresse",
        "loginResult": "Anmeldeergebnis",
        "selectDate": "Datum auswählen",
        "enterDate": "Bitte wählen Sie ein Datum aus",
        "selectStartTime": "Startzeit auswählen",
        "selectEndTime": "Endzeit auswählen",
        "enterUserName": "Bitte geben Sie den Benutzernamen ein",
        "userCount": "Benutzeranzahl",
        "roleDesc": "Rollenbeschreibung",
        "roleAuthorization": "Rollenautorisierung",
        "success": "Erfolgreich",
        "failure": "Fehlgeschlagen",
        "time": "Zeit",
        "operationContent": "Operationsinhalt",
        "playCount": "Wiedergabeanzahl",
        "playDuration": "Wiedergabedauer",
        "selectDevice": "Gerät auswählen",
        "enterProgramName": "Bitte geben Sie den Programmnamen ein",
        "serialNumber": "Seriennummer",
        "publishContentName": "Name des veröffentlichten Inhalts",
        "playMode": "Wiedergabemodus",
        "cyclePlay": "Zyklische Wiedergabe",
        "insertPlay": "Eingebettete Wiedergabe",
        "paddingPlay": "Füllwiedergabe",
        "playDeviceId": "ID des Wiedergabegeräts",
        "playDeviceName": "Name des Wiedergabegeräts",
        "publishTime": "Veröffentlichungszeit",
        "downloadStatus": "Download-Status",
        "notDownloaded": "Nicht heruntergeladen",
        "downloading": "Wird heruntergeladen",
        "downloadSucceeded": "Download erfolgreich",
        "downloadFailed": "Download fehlgeschlagen",
        "enterPublishContentName": "Bitte geben Sie den Namen des veröffentlichten Inhalts ein",
        "terminalId": "Endgeräte-ID",
        "belongOrg": "Zugehörige Organisation",
        "reportTime": "Meldungszeit",
        "reportIp": "Meldungs-IP",
        "logInfo": "Protokollinformationen",
        "details": "Details",
        "confirmDeletion": "Möchten Sie wirklich löschen?",
        "logDetails": "Protokolldetails",
        "download": "Herunterladen",
        "deptOrg": "Abteilungsorganisation",
        "query": "Abfragen",
        "queryByTerminalId": "Nach Endgeräte-ID abfragen",
        "batchDeleteLogs": "Protokolle im Batch löschen",
        "customTimeDeleteLogs": "Protokolle zu benutzerdefinierter Zeit löschen",
        "selectTimeRangeFirst": "Bitte wählen Sie zuerst einen Zeitbereich aus",
        "deleteAllDeviceLogsIfEmpty": "Wenn keine Geräte-ID eingegeben wird, werden standardmäßig die Protokolle aller Geräte gelöscht",
        "enterDeviceIdToDeleteLogs": "Bitte geben Sie die Geräte-ID ein, deren Protokolle gelöscht werden sollen",
        "confirmDeleteAction": "Löschen bestätigen",
        "selectDeleteRangeFirst": "Bitte wählen Sie zuerst den Löschbereich aus",
        "networkConnectionFailed": "Netzwerkverbindung fehlgeschlagen",
        "playLog": "Wiedergabeprotokoll",
        "publishLog": "Veröffentlichungsprotokoll",
        "errorLog": "Fehlerprotokoll",
        "operationLog": "Operationsprotokoll",
        "fileLog": "Dateiprotokoll",
        "userOperateLog": "Anmeldeprotokoll"
    },
    "userManual": {
        "userManual": "Benutzerhandbuch",
        "noData": "Keine Daten verfügbar"
    },
    "systemNotice": {
        "systemNotice": "Systembenachrichtigung",
        "noData": "Keine Daten verfügbar",
        "total": "Gesamt",
        "totalNum": "Stück",
        "markAllRead": "Alle als gelesen markieren",
        "deleteAll": "Alle löschen",
        "all": "Alle",
        "unread": "Ungelesen",
        "read": "Gelesen",
        "type": "Typ",
        "content": "Inhalt",
        "date": "Datum",
        "status": "Status",
        "confirmDelete": "Möchten Sie wirklich löschen?",
        "confirm": "Bestätigen",
        "cancel": "Abbrechen",
        "delete": "Löschen"
    }
};